/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjg2ODMgMy41TDcuMDM0OTIgOS4zMzMzM0wxLjIwMTU5IDMuNUwwLjU4MzI1MiA0LjExODMzTDcuMDM0OTIgMTAuNTdMMTMuNDg2NiA0LjExODMzTDEyLjg2ODMgMy41WiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";